import { useGetFollowUpProgramQuery } from 'src/participant/patientQueries.generated'

export default function useFollowUpProgram(uid: string) {
  const { data, loading, error } = useGetFollowUpProgramQuery({
    fetchPolicy: 'network-only',
    variables: {
      uid,
    },
  })

  const followUpProgram = data?.patient.enrollment.followUpProgram

  return { followUpProgram, loading, error }
}
